import pickedDateAsUtc from './pickedDateAsUtc'

export default function pickedDayAsIso(date: unknown): string {
  const utcDate = pickedDateAsUtc(date)
  if (Number.isNaN(utcDate.getTime())) {
    return ''
  }

  return utcDate.toISOString().slice(0, 10)
}
